@if (initialData) {
    <app-excalidraw
        [initialData]="initialData"
        (onChange)="onChange($event)"
    />
}
